/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import getColor from "@insite/mobius/utilities/getColor";
import { headerStyles } from "@monsma/Overrides/Widgets/MyLists/MyListsHeader";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

headerStyles.container = {
    gap: 15,
    css: css`
        padding-bottom: 30px;
        border-bottom: 1px solid ${getColor("common.border")};
    `,
};

headerStyles.topGridItem = {
    width: 12,
    css: css`
        ${screen("lte", "xs")} {
            order: 1;
        }
    `,
};

headerStyles.bottomLeftGridItem = {
    width: [12, 5, 4, 4, 4],
    css: css`
        ${screen("lte", "xs")} {
            order: 3;
        }
    `,
};

headerStyles.bottomCenterGridItem = {
    width: [12, 5, 4, 4, 4],
    css: css`
        ${screen("lte", "xs")} {
            order: 4;
        }
    `,
};
headerStyles.bottomRightGridItem = {
    width: [12, 2, 4, 4, 4],
    css: css`
        ${screen("lte", "xs")} {
            order: 2;
        }
        align-items: flex-end;
    `,
};
